module.exports = __webpack_public_path__ + "static/media/S-4-Y.e401819b.mp3";